import React from "react";
import { Col, Row } from "react-bootstrap";
import { SummeryCard } from "../../components/SummaryCard/SummeryCard";
import { useQuery } from "react-query";
import { getUserData } from "../../services/dashboardapi";
import Loading from "../../components/Loadings/LoadingTable";
const DashboardApp = ({
  crmData,
  row1_1IconCrm,
  row1_2IconCrm,
  row1_3IconCrm,
  row1_4IconCrm,
  row2_1IconCrm,
  row2_2IconCrm,
  row2_3IconCrm,
  row2_4IconCrm,
  row3_1IconCrm,
  row3_2IconCrm,
  row3_3IconCrm,
  row3_4IconCrm,
  pathName1_1,
  pathName1_2,
  pathName1_3,
  pathName1_4,
  pathName2_1,
  pathName2_2,
  pathName2_3,
  pathName2_4,
  pathName3_1,
  pathName3_2,
  pathName3_3,
  pathName3_4,
}) => {
  const AllSumOrderFormatted = (
    parseInt(crmData?.Sumorder_offlines) + parseInt(crmData?.Sumorder_onlines)
  ).toLocaleString();
  const allPersons = (
    +crmData?.Numbersales_opportunitiesCustomer +
    +crmData?.Numbersales_opportunitiesClue +
    +crmData?.AllNewCustomer +
    +crmData?.Numbersales_opportunitiesVip
  ).toLocaleString();

  const allActions =
    +crmData?.Numbersales_opportunitiesToDay +
    +crmData?.AllActivityListExpired +
    +crmData?.NumberListActivityCrm +
    +crmData?.NumberToDayActivityList;

  const OrderOnlinesFormatted = parseInt(
    crmData?.Sumorder_onlines
  )?.toLocaleString();
  const OrderOfflinesFormatted = parseInt(
    crmData?.Sumorder_offlines
  )?.toLocaleString();
  const InvoiceOrderFormatted = parseInt(
    crmData?.SumCurrentTradesorder_onlines
  ).toLocaleString();
  const OrderUnSuccessfulFormatted = parseInt(
    crmData?.Sumorder_offlines_unsuccessfuls
  )?.toLocaleString();
  return (
    <Row>
      <Col lg={4}>
        <SummeryCard
          title={"فروش"}
          Amount={AllSumOrderFormatted}
          pathname={"/dashboard/accounting/orders"}
          bgColor={"#009ef7"}
          subtitle={"فروش کل"}
          onlineOrderTitle={"فروش حضوری"}
          offlineOrderTitle={"فروش آنلاین"}
          invoiceOrderTitle={"فروش جاری"}
          unsuccessfullTitle={"فروش ناموفق"}
          onlineOrder={OrderOfflinesFormatted}
          offlineOrder={OrderOnlinesFormatted}
          invoiceOrder={InvoiceOrderFormatted}
          unsuccessfull={OrderUnSuccessfulFormatted}
          row1Icon={row1_1IconCrm}
          row2Icon={row1_2IconCrm}
          row3Icon={row1_3IconCrm}
          row4Icon={row1_4IconCrm}
          pathName1={pathName1_1}
          pathName2={pathName1_2}
          pathName3={pathName1_3}
          pathName4={pathName1_4}
        />
      </Col>
      <Col lg={4}>
        <SummeryCard
          title={"اشخاص"}
          Amount={allPersons}
          bgColor={"#f1416c"}
          subtitle={"کل اشخاص"}
          onlineOrderTitle={"مشتری"}
          offlineOrderTitle={"سرنخ"}
          invoiceOrderTitle={"VIP"}
          unsuccessfullTitle={"پرونده های اول"}
          onlineOrder={crmData?.Numbersales_opportunitiesCustomer}
          offlineOrder={crmData?.Numbersales_opportunitiesClue}
          invoiceOrder={crmData?.Numbersales_opportunitiesVip}
          unsuccessfull={crmData?.AllNewCustomer}
          row1Icon={row2_1IconCrm}
          row2Icon={row2_2IconCrm}
          row3Icon={row2_3IconCrm}
          row4Icon={row2_4IconCrm}
          pathName1={pathName2_1}
          pathName2={pathName2_2}
          pathName3={pathName2_3}
          pathName4={pathName2_4}
        />
      </Col>
      <Col lg={4}>
        <SummeryCard
          title={"فعالیت ها"}
          Amount={allActions}
          bgColor={"#50cd89"}
          subtitle={"فرصت ها و فعالیت ها"}
          onlineOrderTitle={"فعالیت های امروز"}
          offlineOrderTitle={"فعالیت های گذشته"}
          invoiceOrderTitle={"فعالیت های انجام شده امروز"}
          unsuccessfullTitle={"سرنخ های امروز"}
          onlineOrder={crmData?.NumberListActivityCrm}
          offlineOrder={crmData?.AllActivityListExpired}
          invoiceOrder={crmData?.NumberToDayActivityList}
          unsuccessfull={
            crmData?.Numbersales_opportunitiesToDay
              ? crmData?.Numbersales_opportunitiesToDay
              : "0"
          }
          row1Icon={row3_1IconCrm}
          row2Icon={row3_2IconCrm}
          row3Icon={row3_3IconCrm}
          row4Icon={row3_3IconCrm}
          pathName1={pathName3_1}
          pathName2={pathName3_2}
          pathName3={pathName3_3}
          pathName4={pathName3_4}
        />
      </Col>
    </Row>
  );
};
export default DashboardApp;
